// Per-user UI prefs that stay user-scoped after the operational fields
// move to ProjectSettings: theme (light/dark/system) and fontSizeScale.
// Reads + writes /api/me/preferences.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

export interface UserPreferences {
  theme: "light" | "dark" | "system";
  fontSizeScale: number;
}

export function useUserPreferences() {
  return useQuery<UserPreferences>({
    queryKey: ["me", "preferences"],
    queryFn: () => api<UserPreferences>("/api/me/preferences"),
    staleTime: 60_000,
  });
}

export function useUpdateUserPreferences() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: Partial<UserPreferences>) =>
      api<UserPreferences>("/api/me/preferences", {
        method: "PATCH",
        body: JSON.stringify(patch),
      }),
    onSuccess: (data) => qc.setQueryData(["me", "preferences"], data),
  });
}
